import { combineReducers } from "redux";
import routing from "./routing";
import stops from "./stops";

export default combineReducers({ routing, stops });
